import { lazy } from 'react'

export const CATEGORIES_ICONS = {
  analytics: lazy(() => import('@mui/icons-material/AnalyticsOutlined')),
  automation: lazy(
    () => import('@mui/icons-material/PrecisionManufacturingOutlined')
  ),
  communication: lazy(() => import('@mui/icons-material/ForumOutlined')),
  compliance: lazy(() => import('@mui/icons-material/PolicyOutlined')),
  content: lazy(() => import('@mui/icons-material/ContentCopyOutlined')),
  customer_service: lazy(
    () => import('@mui/icons-material/HeadsetMicOutlined')
  ),
  finance: lazy(() => import('@mui/icons-material/InsertChartOutlined')),
  growth: lazy(() => import('@mui/icons-material/MovingOutlined')),
  hr: lazy(() => import('@mui/icons-material/PersonOutlined')),
  marketing: lazy(() => import('@mui/icons-material/CampaignOutlined')),
  operations: lazy(() => import('@mui/icons-material/TuneOutlined')),
  performing: lazy(() => import('@mui/icons-material/InsertChartOutlined')),
  product: lazy(
    () => import('@mui/icons-material/ProductionQuantityLimitsOutlined')
  ),
  research: lazy(() => import('@mui/icons-material/ScienceOutlined')),
  sales: lazy(() => import('@mui/icons-material/CampaignOutlined')),
  strategy: lazy(() => import('@mui/icons-material/TimelineOutlined')),
  support: lazy(() => import('@mui/icons-material/HeadsetMicOutlined')),
  technology: lazy(() => import('@mui/icons-material/LaptopMacOutlined')),
  training: lazy(() => import('@mui/icons-material/SchoolOutlined')),
  // other
  other: lazy(() => import('@mui/icons-material/CategoryOutlined')),
}
